import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получение списка сигналов
export const apiGetSignalsData = async (nextPageUrl) => {
  const url = nextPageUrl || `${backendUrl}/api/signals/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка сигналов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch{
    throw error;
  }
};